<div class="container py-2">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ "Loading..." | translate }}</span>
    </div>
    <p class="mt-3">{{ "evaluatedInterview.loading" | translate }}</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && interviews.length === 0" class="text-center py-5">
    <img src="../../../../assets/img/floating-robot 1.png" alt="No interviews" style="width: 150px; opacity: 0.5;" />
    <h5 class="mt-4">{{ "evaluatedInterview.emptyTitle" | translate }}</h5>
    <p class="text-muted">{{ "evaluatedInterview.emptyHint" | translate }}</p>
  </div>

  <!-- Interviews Grid -->
  <div class="row g-4" *ngIf="!isLoading && interviews.length > 0">
    <div class="col-12 col-md-4" *ngFor="let interview of interviews; let i = index">
      <div class="interview-card">

        <!-- Robot Image -->
        <img src="../../../../assets/img/floating-robot 1.png" alt="robot" class="robot-img" />

        <!-- Text -->
        <div class="text-content">
          <h6 class="title">{{ interview.jobTitle }}</h6>
          <p class="attempt">{{ interview.sessionNumber}}</p>
          <!-- <p class="date" *ngIf="interview.reportSummary.interviewDate">
            {{ interview.reportSummary.interviewDate | date: 'MMM d, yyyy' }}
          </p> -->
        </div>

        <!-- Button -->
        <button class="view-btn" (click)="viewEvaluation(interview)">
          {{ "evaluatedInterview.viewEvaluation" | translate }}
        </button>

      </div>
    </div>
  </div>
</div>
